(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["warranty-contact-form"] && !Shopify.designMode) return;
  try {
    function initializeWarrantyMultiselects(root) {
    const searchRoot = root || document;

    searchRoot
      .querySelectorAll('[data-warranty-multiselect]')
      .forEach(function (multiselect) {
        if (multiselect.dataset.initialized === 'true') return;

        const options = multiselect.querySelectorAll(
          '[data-warranty-multiselect-option]'
        );
        const hiddenField = multiselect.querySelector(
          '[data-warranty-multiselect-value]'
        );
        const summary = multiselect.querySelector(
          '[data-warranty-multiselect-summary]'
        );
        const placeholder =
          multiselect.dataset.placeholder || 'Select all that apply';

        if (!options.length || !hiddenField || !summary) return;

        function updateSelections() {
          const selected = Array.from(options)
            .filter(function (option) {
              return option.checked;
            })
            .map(function (option) {
              return option.value;
            });

          hiddenField.value = selected.join(', ');

          if (selected.length === 0) {
            summary.textContent = placeholder;
          } else if (selected.length === 1) {
            summary.textContent = selected[0];
          } else {
            summary.textContent = selected.length + ' options selected';
          }
        }

        options.forEach(function (option) {
          option.addEventListener('change', updateSelections);
        });

        const form = multiselect.closest('form');
        if (form) {
          form.addEventListener('submit', updateSelections);
        }

        updateSelections();
        multiselect.dataset.initialized = 'true';
      });
  }

  function loadWarrantyMultiselects() {
    initializeWarrantyMultiselects(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      loadWarrantyMultiselects
    );
  } else {
    loadWarrantyMultiselects();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeWarrantyMultiselects(event.target);
    }
  );
  } catch(e) { console.error(e); }
})();

})();
